




























import {
    defineComponent,
    PropType,
    onMounted,
    reactive,
} from '@vue/composition-api';
import { convertLrpxToRem } from '@/common/util';
import { sendTaskLog } from '@/common/log';

import { Swiper as MSwiper } from '@kibt/meta-ui';
import ImageItem from './ImageItem.vue';

import { DynamicImage } from '../../type';

export default defineComponent({
    name: 'ImageSwiper',
    components: { MSwiper, ImageItem },
    props: {
        images: {
            type: Array as PropType<DynamicImage[]>,
            default: () => [],
        },
    },
    setup(props) {
        const state = reactive({
            swiperHeight: 0,
            currentSwiperIdx: 0,
            reportLog: false,
        });

        function getSwiperHeight() {
            const { height = 0, width = 0 } =
                props?.images?.[0]?.normalImgInfo || {};
            const imageHeight = (height * window.innerWidth) / width;
            if (imageHeight > 520) {
                return 520;
            }
            if (imageHeight < 200) {
                return 200;
            }
            return imageHeight || 520;
        }

        onMounted(() => {
            state.swiperHeight = getSwiperHeight();
        });

        function onSwiperChange(index) {
            if (!state.reportLog) {
                state.reportLog = true;
            } else if (state.currentSwiperIdx !== index + 1) {
                // 同一张图片不会重复上报埋点
                sendTaskLog({
                    name: 'SLIDE',
                });
            }

            state.currentSwiperIdx = index + 1;
        }
        return {
            props,
            state,
            onSwiperChange,
            convertLrpxToRem,
        };
    },
});
